import { render, staticRenderFns } from "./TranslationsButton.vue?vue&type=template&id=77a14d32&scoped=true&"
import script from "./TranslationsButton.vue?vue&type=script&lang=ts&"
export * from "./TranslationsButton.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsButton.vue?vue&type=style&index=0&id=77a14d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a14d32",
  null
  
)

export default component.exports